export default "__VITE_ASSET__JbF6gw3G__"